export const API_PATH_ApiDeviceMgmtDeviceChangeId = '/services/device-mgtm/apiDeviceMgmtDeviceChangeId';
